import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var featureFlags = function featureFlags(featureFlagClient, _featureFlags, data) {
  var allFeatureFlags = [].concat(_toConsumableArray(_featureFlags), _toConsumableArray(data.featureFlags || []));
  if (allFeatureFlags.length === 0) {
    return null;
  }
  var initialMemo = [];
  allFeatureFlags.reduce(function (memo, featureFlagKey) {
    var ffVal = featureFlagClient.getValue(featureFlagKey);
    if (ffVal !== undefined && ffVal !== null) {
      memo.push([featureFlagKey, ffVal]);
    }
    return memo;
  }, initialMemo);
  var mappedFeatureFlags = Object.fromEntries(initialMemo);
  return {
    featureFlags: mappedFeatureFlags
  };
};